import { AwardsModulePartner } from '../../../types/components'

const ModulePartnerPage = ({
  moduleProps
}: {
  moduleProps: AwardsModulePartner['attributes']
}) => {
  return (
    <div className='pt-[80px] md:pt-[200px] lg:pt-[200px]'>
      <div className='flex flex-col items-center w-full space-y-[-2px] font-sans text-[#1E1E1E]'>
        <div className='flex flex-col items-center w-full gap-[100px] px-4'>
          <div className='flex flex-col items-center mb-[70px]'>
            <h2 className='text-[25px] md:text-[53px] mb-[35px] lg:mb-[10px] font-bold leading-[0.85] text-center uppercase whitespace-pre-line font-abcd'>
              {moduleProps.mainHeading}
            </h2>
            <p className='text-[16px] leading-[1] tracking-[-0.05em] text-center max-w-3xl font-swinton'>
              {moduleProps.title}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModulePartnerPage
